module.exports = __webpack_public_path__ + "static/media/facebook-container-nick.5854015a.svg";